import {IEnumListEntry} from "../definitions";
export const HIT_TYPES = {
    NONE: 0,
    BEST_PRICE: 1,
    PROFITABLY: 2,
    LEVEL_UP: 3,
    PLAYERS_CHOICE: 4
};


export const HIT_TYPES_LIST:IEnumListEntry[] = [
    { id: HIT_TYPES.NONE, label: "NONE" },
    { id: HIT_TYPES.BEST_PRICE, label: "BEST_PRICE" },
    { id: HIT_TYPES.PROFITABLY, label: "PROFITABLY" },
    { id: HIT_TYPES.LEVEL_UP, label: "LEVEL_UP" },
    { id: HIT_TYPES.PLAYERS_CHOICE, label: "PLAYERS_CHOICE" }
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-hit-type.ts